var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blogArchive"},[_c('Pagination',{staticClass:"m-n3",attrs:{"data":_vm.blogs.grid,"perPage":5,"blog":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }